module.exports = __webpack_public_path__ + "media/images/illustration/undraw_For_sale_re_egkk-4dee6aa168b5a09741fe13d9b0456a47.svg";